import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router';
import { QuestionnaireConsumer } from 'contexts/QuestionnaireContext';


export class QuestionnaireRoute extends React.Component<RouteProps, {}>
{
	render() {
		return <QuestionnaireConsumer>
			{
				({ questionnaire, token }) => {
					if (questionnaire !== null && token !== null)
						return <Route {... this.props} />
					else
						return <Redirect to='/questionnaire'/>
				}
			}
		</QuestionnaireConsumer>
	}
}